// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorAlert_root__SXuqp","body":"ErrorAlert_body__HbTWB","button":"ErrorAlert_button__pmuHn"};